<template>
  <div>
    <h5 class="title is-5 has-text-primary">
      {{league.title}}
    </h5>
    <hr>

    <div class="media">

      <figure class="media-left">
        <span class="icon">&nbsp;</span>
      </figure>

      <div class="media-content over-flow-inherit">
        <game v-for="(game, i) in games"
              :key="game._id"
              :game="game"
              @picked="handlePick"
              :class="`${i !== games.length - 1 ? 'mb-6' : ''}`"
              :parlay="parlay" />
      </div>

    </div>
  </div>
</template>

<script>
import Game from '@/components/admin/Game';

export default {
  components: {
    Game
  },
  props:{
    league: Object,
    parlay: Boolean
  },
  methods: {
    handlePick: function (e) {
      if (!this.parlay) {
        return this.$emit('picked', e);
      }

      return this.$emit('parlayPicked', e);
    }
  },
  computed: {
    games: function () {
      let { league = {}} = this;
      if (!('games' in league)){
        return [];
      }

      if (!Array.isArray(league.games)) {
        return [];
      }

      return  league.games.filter(game => {
        return 'lineBetFormatted' in game && 'current' in game.lineBetFormatted;
      });
    }
  }
}
</script>